import React, { CSSProperties, PropsWithChildren } from 'react';
import { motion } from 'motion/react';

export enum FadeInDirectionType {
  none, rtl, ltr, dtu, utd,
}
interface AnimationTextType {
  direction:FadeInDirectionType | FadeInDirectionType.none,
  duration?:number | 1,
  delay?:number | 0,
  fadeInDistance:number | 0,
  style?:CSSProperties
}
export const FadeWrapper:React.FC<PropsWithChildren<AnimationTextType>> = (props:PropsWithChildren<AnimationTextType>) => (
  <motion.div
    style={props.style}
    initial={{
      opacity: 0,
      translateX: props.direction === FadeInDirectionType.rtl ? props.fadeInDistance : props.direction === FadeInDirectionType.ltr ? props.fadeInDistance * -1 : 0,
      translateY: props.direction === FadeInDirectionType.dtu ? props.fadeInDistance : props.direction === FadeInDirectionType.utd ? props.fadeInDistance * -1 : 0,
    }}
    viewport={{
      once: true,
    }}
    whileInView={{
      opacity: 1,
      translateX: 0,
      translateY: 0,
      transition: {
        duration: props.duration,
        delay: props.delay,
      },
    }}
  >
    {props.children}
  </motion.div>
);
